import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.admin,
    routes: [{ path: '/close-day', component: FuseLoadable({ loader: () => import('./CloseDayApp') }) }],
};

export default [Index];
